export const storage = {
  setItem: (key, value, rememberMe) => {
    const targetStorage = rememberMe ? localStorage : sessionStorage;
    targetStorage.setItem(key, value);
  },
  getItem: (key) => {
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
    sessionStorage.clear();
  },
};
